import React, { useRef, useState } from 'react';
import { Menu } from 'react-feather';

import './main-menu.styles.scss';
import { withRouter } from 'react-router-dom';
import useClickOutside from '../../../utils/useClickOutside';
import ComponentGuard from '../../component-guard/ComponentGuard';
import { redirectToBillingService } from '../../../utils/common.util';

const MenuItem = ({ text, action }) => {
  return (
    <div className="menu-item" onClick={action}>
      {text}
      <hr className="separator" />
    </div>
  );
};

const MainMenu = ({ history }) => {
  const [showMenu, setShowMenu] = useState(false);
  const mainMenuRef = useRef(null);
  useClickOutside(mainMenuRef, () => setShowMenu(false), {
    closeOnEscape: true,
  });
  return (
    <div className={`nav-menu`} ref={mainMenuRef}>
      <p
        className={`heading ${showMenu}`}
        onClick={() => {
          /* if (!showMenu) {
							setTimeout(() => setShowMenu(false), 2000);
						} */
          setShowMenu(!showMenu);
        }}
      >
        <Menu size={20} /> <span>MAIN MENU</span>
      </p>

      {showMenu ? (
        <div className="menu-items">
          {MENU_ITEMS.map((item) => (
            <ComponentGuard key={item.path} allowedRoles={item?.allowedRoles}>
              <MenuItem
                key={item.path}
                text={item.text}
                // action={() => history.push(item.path)}
                action={() => {
                  typeof item.path === 'function'
                    ? item.path()
                    : history.push(item.path);
                  setShowMenu(false);
                }}
              />
            </ComponentGuard>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default withRouter(MainMenu);

const MENU_ITEMS = [
  { text: 'DASHBOARD', path: '/' },
  {
    text: 'ACADEMIC YEAR',
    path: '/academic-year',
    allowedRoles: ['AcademicYearAccess', 'AcademicYearAccessReadOnly'],
  },
  {
    text: 'BUDGETS',
    path: '/budget',
    allowedRoles: ['BudgetAccess', 'BudgetAccessReadOnly'],
  },
  {
    text: 'STUDENTS',
    path: '/student',
    allowedRoles: ['StudentsAccess', 'StudentsAccessReadOnly'],
  },
  {
    text: 'CLASS',
    path: '/class',
    allowedRoles: ['ClassAccess', 'ClassAccessReadOnly'],
  },
  {
    text: 'EMPLOYEES',
    path: '/employees',
    allowedRoles: ['EmployeeAccess', 'EmployeeAccessReadOnly'],
  },
  {
    text: 'SUPPLIERS',
    path: '/suppliers',
    allowedRoles: ['SuppliersAccess', 'SuppliersAccessReadOnly'],
  },
  {
    text: 'PURCHASES',
    path: '/suppliers/purchases',
    allowedRoles: ['ExpensesAccess', 'ExpensesAccessReadOnly'],
  },
  {
    text: 'LEDGERS',
    path: '/chart-of-accounts',
    allowedRoles: ['LedgersAccess', 'LedgersAccessReadOnly'],
  },
  {
    text: 'JOURNAL',
    path: '/journal',
    allowedRoles: ['JournalVoucherAccess', 'JournalVoucherAccessReadOnly'],
  },
  {
    text: 'BILLING',
    path: '/billing',
    allowedRoles: ['BillingAccess', 'BillingAccessReadOnly'],
  },
  {
    text: 'CASH RECEIVED',
    path: '/payments-received',
    allowedRoles: ['RevenueAccess', 'RevenueAccessReadOnly'],
  },
  {
    text: 'EXPENSES',
    path: '/payments-made',
    allowedRoles: ['ExpensesAccess', 'ExpensesAccessReadOnly'],
  },
  {
    text: 'PAYROLL',
    path: '/payroll',
    allowedRoles: ['PayrollAccess', 'PayrollAccessReadOnly'],
  },
  {
    text: 'FIXED ASSET',
    path: '/fixed-asset',
    allowedRoles: ['FixedAssetAccess', 'FixedAssetAccessReadOnly'],
  },
  { text: 'JOURNAL VOUCHER', path: '/transaction' },
  {
    text: 'ACADEMICS',
    path: '/academic',
    allowedRoles: ['AcademicAccess', 'AcademicAccessReadOnly'],
  },
  {
    text: 'MESSAGING',
    path: '/messaging',
    allowedRoles: ['MessagingAccess', 'MessagingAccessReadOnly'],
  },
  { text: 'ANALYTICS', path: '/analytics', allowedRoles: ['AnalyticsAccess'] },
  {
    text: 'SETTINGS',
    path: '/settings',
    allowedRoles: ['SettingsAccess', 'SettingsAccessReadOnly'],
  },
  {
    text: 'SUBSCRIPTION',
    path: () => redirectToBillingService('billing'),
    allowedRoles: ['SubscriptionAccess'],
  },
  {
    text: 'DAILY FEE COLLECTION',
    path: '/daily-fees',
    allowedRoles: ['DailyBillingFeesAccess', 'DailyBillingFeesAccessReadOnly'],
  },
  {
    text: 'HELP & SUPPORT',
    path: () => window.open('https://epobssuite.com', '_blank'),
  },
];
